import { ref, onUnmounted, watch, isRef } from 'vue'

// Module-level reactive ref — shared between the focus layout and page components
const focusMobileTitle = ref(null)

/**
 * Sets the mobile title in the focus layout header.
 * Accepts a static string or a reactive ref (for dynamic titles).
 * Clears the title when the component unmounts.
 *
 * @param {string|import('vue').Ref<string>} title
 */
export function useFocusMobileTitle(title) {
  if (isRef(title)) {
    const stop = watch(title, v => { focusMobileTitle.value = v }, { immediate: true })
    onUnmounted(() => { stop(); focusMobileTitle.value = null })
  } else if (title != null) {
    focusMobileTitle.value = title
    onUnmounted(() => { focusMobileTitle.value = null })
  }

  return { focusMobileTitle }
}
